import { useState, useRef, useEffect } from "react";
import { GoogleMapsProvider } from "@ubilabs/google-maps-react-hooks";
import Location from "./Location";

const Map = () => {
  const [mapContainer, setMapContainer] = useState(null);

  const mapOptions = {
    zoom: 15,
    center: {
      lat: 53.6167727,
      lng: -6.2011085,
    },
  };

  return (
    <div className="h-full w-full">
      <GoogleMapsProvider
        googleMapsAPIKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}
        mapContainer={mapContainer}
        mapOptions={mapOptions}
      >
        <div
          ref={(node) => setMapContainer(node)}
          className="w-full h-96"
        />
        <Location />
      </GoogleMapsProvider>
    </div>
    // <div ref={ref} className="w-full h-full"/>
    // <div className="flex h-full bg-white">
    //   <div className="w-full h-full">
    //     <GoogleMap
    //     // zoom={10}
    //     // center={center}
    //     // passive={true}
    //     // className="w-full h-screen"
    //     >
    //       <div ref={ref} className="h-full w-full"></div>
    //     </GoogleMap>
    //   </div>
    // </div>
  );
};

export default Map;
